import React, { useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import { makeStyles } from '@material-ui/core'
import PicExpand from './PicExpand'
import Caption from '../StoryItemCaption'

import './StoryItemPDF.css'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`


const useStyles = makeStyles({
  root: {
    position: 'relative',
  }
})

export default function StoryItemPDF(props) {

  const { asset, showPDF } = props

  const classes = useStyles()

  const [numPages, setNumPages] = useState(null)

  const handlePDFSuccess = (document) => {
    const { numPages } = document
    setNumPages(numPages)
  }

  const handlePageSuccess = () => {
    window.dispatchEvent(new Event('resize'))
  }

  const handlePDFExpandClick = () => {
    showPDF(asset.link)
  }


  return (
    <div className={classes.root}>
      <PicExpand click={handlePDFExpandClick} />
      <Document
        file={asset.link}
        onLoadSuccess={handlePDFSuccess}>
        {Array.from(
          new Array(numPages),
          (_, index) => (
            <Page
              object-fit="fill"
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              onLoadSuccess={handlePageSuccess} />
          ),
        )}
      </Document>
      <Caption asset={asset} />
    </div>
  )
}